/* DEEM — premium interacties & effecten. Geen libraries, performance-bewust. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Scroll-voortgangsbalk bovenaan */
  function progressBar() {
    var bar = document.createElement('div');
    bar.className = 'deem-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      bar.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* 2. Scroll-reveal: elementen komen in beeld met een lichte stagger */
  function reveal() {
    /* Meld dat dit script draait. Het regeltje in de head kijkt hiernaar: is
       deze markering er na twee seconden niet, dan haalt het de klasse weg
       die de inhoud verbergt en staat alles er gewoon. Zo kan een blokkade,
       een trage verbinding of een fout in een ander script de site nooit
       leeg laten. */
    document.documentElement.classList.add('deem-reveal-actief');

    var els = document.querySelectorAll('.deem-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          // stagger op basis van volgorde binnen de ouder
          var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
          el.style.transitionDelay = Math.min(sibs * 90, 600) + 'ms';
          el.classList.add('is-in');
          io.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      // Alles wat al (bijna) in beeld staat bij het laden: meteen tonen, geen wachten.
      var top = el.getBoundingClientRect().top;
      if (top < vh * 0.92) { el.classList.add('is-in'); }
      else { io.observe(el); }
    });
  }

  /* 3. Typewriter: [data-typewriter] typt zijn tekst wanneer in beeld */
  function typewriter() {
    var els = document.querySelectorAll('[data-typewriter]');
    if (!els.length) return;
    els.forEach(function (el) {
      var full = el.getAttribute('data-typewriter');
      if (reduce) { el.textContent = full; return; }
      el.textContent = '';
      el.classList.add('deem-caret');
      var started = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !started) {
            started = true;
            var i = 0;
            (function tick() {
              if (i <= full.length) {
                el.textContent = full.slice(0, i);
                i++;
                setTimeout(tick, 45 + Math.random() * 50);
              } else {
                el.classList.remove('deem-caret');
              }
            })();
            io.disconnect();
          }
        });
      }, { threshold: 0.6 });
      io.observe(el);
    });
  }

  /* 4. Getekende onderstreping: .deem-draw tekent zijn SVG-pad in beeld */
  function drawLines() {
    var els = document.querySelectorAll('.deem-draw path');
    if (!els.length || reduce) {
      document.querySelectorAll('.deem-draw').forEach(function (s) { s.classList.add('is-drawn'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.closest('.deem-draw').classList.add('is-drawn'); io.unobserve(e.target); }
      });
    }, { threshold: 0.8 });
    els.forEach(function (p) { io.observe(p); });
  }

  /* 5. Zachte spotlight die de muis volgt op kaarten */
  function spotlight() {
    if (reduce) return;
    document.querySelectorAll('.deem-card, .deem-cta').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        el.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  /* 6. Lichte parallax op elementen met [data-parallax] */
  function parallax() {
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var pct = (r.top + r.height / 2 - vh / 2) / vh;
        var amt = parseFloat(el.getAttribute('data-parallax')) || 20;
        el.style.transform = 'translateY(' + (pct * amt * -1) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* 7. Count-up op cijfers (.deem-stat__num en [data-countup]) */
  function countUp() {
    var els = document.querySelectorAll('.deem-stat__num, [data-countup]');
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var full = (el.getAttribute('data-countup') || el.textContent).trim();
        var m = full.match(/([^\d]*)(\d[\d.,]*)(.*)/);
        if (!m) return;
        var pre = m[1], numStr = m[2].replace(/[.,]/g, ''), suf = m[3];
        var target = parseInt(numStr, 10);
        if (isNaN(target) || target < 2) return;
        var dur = 1300, start = performance.now();
        function frame(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(target * eased);
          el.textContent = pre + val.toLocaleString('nl-NL') + suf;
          if (p < 1) requestAnimationFrame(frame);
          else el.textContent = pre + target.toLocaleString('nl-NL') + suf;
        }
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    progressBar();
    reveal();
    typewriter();
    drawLines();
    spotlight();
    parallax();
    countUp();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
